export default __webpack_public_path__ + "locales/cs/DeleteThirdPartyDialog.json?hash=728a7a2bfe6e7e6c76507413a491025e";